import { NgClass } from '@angular/common'
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faQuestionCircle, faTriangleExclamation, IconDefinition } from '@fortawesome/free-solid-svg-icons'

type InfoType = 'info' | 'caution'

const iconMap: Record<InfoType, IconDefinition> = {
  info: faQuestionCircle,
  caution: faTriangleExclamation
}

@Component({
  selector: 'app-info-card',
  imports: [FontAwesomeModule, NgClass],
  templateUrl: './info-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './info-card.component.scss'
})
export class InfoCardComponent {
  type = input.required<InfoType>()
  iconOverride = input<IconDefinition>()
  icon = computed<IconDefinition>(() => this.iconOverride() || iconMap[this.type()])
  addClass = input<string>('')
}
